import { CSSObject } from '@chakra-ui/react';

export const LinkWrapper: CSSObject = {
  color: 'beta.800',
};
